import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const QuotationTemplates = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="page-header">
          <div className="container">
            <h1 className="page-title">Quotation Templates</h1>
            <p className="page-subtitle">Manage quotation templates</p>
          </div>
        </div>

        <div className="container">
          <div className="empty-state">
            <div className="empty-icon">📝</div>
            <div className="empty-text">Templates Coming Soon</div>
            <div className="empty-subtext">This feature is under development</div>
            <button onClick={() => navigate('/dashboard')} className="btn btn-primary" style={{ marginTop: '20px' }}>
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationTemplates;
